import { create, StateCreator } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { createSelectors } from './utils';

interface MembershipsConfigState {
  configPanelWidth: number | null;
  setConfigPanelWidth: (width?: number | null) => void;
}

const membershipsConfigInitializer: StateCreator<MembershipsConfigState> = (set) => ({
  configPanelWidth: null,
  setConfigPanelWidth: (width?: number | null) => set({ configPanelWidth: width ?? null }),
});

const useMembershipsConfigStoreRaw = create<
  MembershipsConfigState,
  [['zustand/persist', unknown]]
>(
  persist(
    (...args) => ({
      ...membershipsConfigInitializer(...args),
    }),
    {
      name: 'pt-memberships-config',
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);

export const useMembershipsConfigStore = createSelectors(useMembershipsConfigStoreRaw);

